import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { reportgmroireport } from 'utils/breadcrumbInfo';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getGmroiReport, getGeneralReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import reportsUtil from 'utils/reportsApi';
import Grid from 'screens/components/basic/Grid';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import WithRouter from 'custom/withRouter';

class GMROIReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date();
        this.props.formInput(date, `GMROIReportSelectedDate`)
    }

    getReport = () => {
        let branch = this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch;
        let selectedDate = this.props.selectedDate || moment().format("YYYY-MM-DD");

        this.props.getGmroiReport({ branch, selectedDate });
    }

    downloadReport = () => {
        let branch = this.props.selectedBranch;
        let selectedDate = this.props.selectedDate;

        this.props.getCsvReport(`reports/excel/gmroiReport?branch=${branch}&selectedDate=${selectedDate}`, "GMROI");
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    cleanSearch = () => {
        this.props.clearFormInput(`InventoryLevelWarehouse`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        this.filter();
        this.setState({ showBody: true });
    }

    render() {
        const totalRow = this.props.gmroi ? this.props.gmroi.length > 0 ? this.props.gmroi.length : 0 : 0;
        return (
            <Grid headerContent={reportgmroireport}>
                <PageHeader title={LOOKUP.report.gmroiReport.text} description={LOOKUP.report.gmroiReport.description} icon={<KnowledgeBase  link="https://knowledge.techpos.ca/en/knowledge/what-is-the-gmroi-report" />} />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                />
                {
                    this.state.showBody &&
                    <CardSimple className="mt-2">
                        <Body gmroi={this.props.gmroi} selectedDate={this.props.selectedDate} />
                    </CardSimple>
                }
            </Grid>
        )
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    return {
        brachOptions: brachOptions,
        loggedBranch: state.common.branchId,
        selectedBranch: state.form.GMROIReportBranchOption,
        selectedDate: moment(state.form.GMROIReportSelectedDate).format("YYYY-MM-DD"),
        gmroi: state.reports.gmroi
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getGmroiReport: (model) => dispatch(getGmroiReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(GMROIReport));